import {PAGINATION_CHANGE} from 'app/redux/constants/actionTypes';

const initialState = {
  current: 1,
};

export default function pagination(state = initialState, action) {
  switch (action.type) {
    case PAGINATION_CHANGE:
      return {
        ...state,
        current: action.values.current
      };
    default: 
      return state;
  }
}